import { render, staticRenderFns } from "./safe-recorddetail.vue?vue&type=template&id=583d74d7&scoped=true&"
import script from "./safe-recorddetail.vue?vue&type=script&lang=js&"
export * from "./safe-recorddetail.vue?vue&type=script&lang=js&"
import style0 from "./safe-recorddetail.vue?vue&type=style&index=0&id=583d74d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583d74d7",
  null
  
)

export default component.exports